import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AuthPage from './pages/AuthPage';
import Dashboard from './pages/Dashboard';
import Processing from './pages/Processing';
import Offers from './pages/Offers';
import Success from './pages/Success';
import LoanHistory from './pages/LoanHistory';
import Calculator from './pages/Calculator';
import Support from './pages/Support';
import AdminDashboard from './pages/AdminDashboard';
import { TermsPage, PrivacyPage } from './pages/LegalPages';
import './styles/main.css';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/"           element={<AuthPage />} />
          <Route path="/dashboard"  element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/processing" element={<ProtectedRoute><Processing /></ProtectedRoute>} />
          <Route path="/offers"     element={<ProtectedRoute><Offers /></ProtectedRoute>} />
          <Route path="/success"    element={<ProtectedRoute><Success /></ProtectedRoute>} />
          <Route path="/history"    element={<ProtectedRoute><LoanHistory /></ProtectedRoute>} />
          <Route path="/calculator" element={<ProtectedRoute><Calculator /></ProtectedRoute>} />
          <Route path="/support"    element={<ProtectedRoute><Support /></ProtectedRoute>} />
          <Route path="/admin"      element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          <Route path="/terms"      element={<TermsPage />} />
          <Route path="/privacy"    element={<PrivacyPage />} />
          <Route path="*"           element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
